import { useQsFilters } from "@dash/filters";

import { CartFilters, cartFiltersSerializer, getMegaraxPath } from "@megaron/megarax-uri";

export type CartsFiltersType = CartFilters;

export const buildCartsListUrlForCustomer = (customerUuid: string) =>
  getMegaraxPath.uri("megarax://loyalty/carts", {
    filters: { page: 0, searchTerm: customerUuid },
  });

export const useCartsFilters = () => {
  const defaultFilters: CartsFiltersType = {
    page: 0,
    isArchived: false,
    isFulfilled: undefined,
    hasRewards: undefined,
    excludeEmpty: true,
  };

  const { filters, setFilters } = useQsFilters(cartFiltersSerializer, defaultFilters);

  const setFilter =
    <K extends keyof CartsFiltersType>(key: K) =>
    (value: CartsFiltersType[K]) =>
      setFilters({ ...filters, [key]: value });

  return { filters, setFilter, setFilters, defaultFilters };
};
